import { Outlet } from "react-router-dom";
import { BottomNavbar } from "./BottomNavbar";
import { useInitializeDaysRangeFromUser } from "@/hooks/useInitializeDaysRangeFromUser";

export function AppLayout() {
  useInitializeDaysRangeFromUser();
  //const location = useLocation();

  // Check if the route is not recognized within the app section
  // This is to handle nested routes that don't exist but match the /* pattern
  // const validAppPaths = [
  //   "",
  //   "/track",
  //   "/track/manual",
  //   "/workouts",
  //   "/settings",
  //   "/settings/exercises",
  //   "/settings/preferences",
  //   "/settings/profile",
  //   "/stats",
  // ];

  // const isValidPath = validAppPaths.some(
  //   (path) =>
  //     location.pathname === path ||
  //     (path.endsWith("/") && location.pathname.startsWith(path))
  // );

  // console.log("isValidPath:", isValidPath, location.pathname);

  // if (!isValidPath) {
  //   return <Navigate to="/404" replace />;
  // }

  return (
    <div className="min-h-screen max-w-md mx-auto flex flex-col">
      <main className="flex-1 pt-6 pb-32 overflow-y-auto">
        <Outlet />
      </main>
      <BottomNavbar />
    </div>
  );
}
